'use strict';

import angular from 'angular';
import frame from './frame.controller';

export default angular.module('bfastCaptureManagerApp.application.frame', [])
  .controller('AppFrameController', frame)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/frame/index.js